import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface IFreightDetailFreightHandlingAttributes extends IModelAttributes {
	freightDetailId: string;
	freightHandlingId: string;

	freightDetail: Models.FreightDetailEntity | Models.IFreightDetailEntityAttributes;
	freightHandling: Models.FreightHandlingEntity | Models.IFreightHandlingEntityAttributes;
}

@entity('FreightDetailFreightHandling')
export default class FreightDetailFreightHandling extends Model implements IFreightDetailFreightHandlingAttributes {
	@observable
	@attribute()
	public freightDetailId: string;

	@observable
	@attribute()
	public freightHandlingId: string;

	@observable
	@attribute({ isReference: true })
	public freightDetail: Models.FreightDetailEntity;

	@observable
	@attribute({ isReference: true })
	public freightHandling: Models.FreightHandlingEntity;

	constructor(attributes?: Partial<IFreightDetailFreightHandlingAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.freightDetailId) {
				this.freightDetailId = attributes.freightDetailId;
			}
			if (attributes.freightHandlingId) {
				this.freightHandlingId = attributes.freightHandlingId;
			}

			if (attributes.freightDetail) {
				if (attributes.freightDetail instanceof Models.FreightDetailEntity) {
					this.freightDetail = attributes.freightDetail;
					this.freightDetailId = attributes.freightDetail.id;
				} else {
					this.freightDetail = new Models.FreightDetailEntity(attributes.freightDetail);
					this.freightDetailId = this.freightDetail.id;
				}
			} else if (attributes.freightDetailId !== undefined) {
				this.freightDetailId = attributes.freightDetailId;
			}

			if (attributes.freightHandling) {
				if (attributes.freightHandling instanceof Models.FreightHandlingEntity) {
					this.freightHandling = attributes.freightHandling;
					this.freightHandlingId = attributes.freightHandling.id;
				} else {
					this.freightHandling = new Models.FreightHandlingEntity(attributes.freightHandling);
					this.freightHandlingId = this.freightHandling.id;
				}
			} else if (attributes.freightHandlingId !== undefined) {
				this.freightHandlingId = attributes.freightHandlingId;
			}
		}
	}
}
